import { format } from 'date-fns'

export const localeFormatDate = (date: Date | string) =>
  format(new Date(date), 'dd/MM/yyyy HH:mm')
